import React from "react";
import { Bouncer } from "components/HomeRepairAuthProvider";
import HomeRepairManagementHeader from "components/design-system/organisms/HomeRepairManagementHeader";
import Box from "@material-ui/core/Box";

const HomeRepairManagementLayout: React.FunctionComponent = ({ children }) => {
  return (
    <Box flexDirection="column" height="100vh" display="flex">
      <HomeRepairManagementHeader />
      <Bouncer>{children}</Bouncer>
    </Box>
  );
};

export default HomeRepairManagementLayout;
